module.exports = __webpack_public_path__ + "static/media/striped-background.png";